import { Component, OnInit, OnDestroy } from '@angular/core';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';

import { EChartsOption } from 'echarts';


@Component({
  selector: 'app-follow-work',
  templateUrl: './follow-work.component.html',
  styleUrls: ['./follow-work.component.css']
})
export class FollowWorkComponent {
  chartOptions_area: EChartsOption = {};
  chartOptions_Assess: EChartsOption = {};
  chartOptions_crop_loss: EChartsOption = {};
  chartOptions_yield: EChartsOption = {};

  chartOptions_aaa: EChartsOption = {};
  chartOptions_aaa_m: EChartsOption = {};
  chartOptions_factors: EChartsOption = {};
  chartOptions_factors2: EChartsOption = {};


  year_L = [    //รายการปี
    // { "yearTh": "6768", "yearCr": "2425", "yearDesc": "ปี 2567/2568", "state": 0 },
    { "yearTh": "6869", "yearCr": "2526", "yearDesc": "ปี 2568/2569", "state": 0 },
    { "yearTh": "6970", "yearCr": "2627", "yearDesc": "ปี 2569/2570", "state": 1 },
  ]
  year_S: any = {};//ปีที่เลือก

  ngOnInit(): void {
    this.year_S = this.year_L.filter((el) => (el.state) == 1)[0];
    this.Loadkpiall();
  }

  loader = [false, false]
  data_list = [];
  Loadkpiall() {
    let year = this.year_S;
    this.loader[0] = true;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_follow_on_work_${year.yearTh}]&w=1=1`;
    axios.get(url).then(res => {
      let data = res.data
      this.loader[0] = false;
      //console.log('Loadkpiall:', data);
      if (data.length > 0) {
        //data.sort((a, b) => a.supzone.localeCompare(b.supzone));
        data = data.map(item => {
          return {
            ...item
            , sum_organic: item.Organic_powder_bulk + item.Organic_granular + item.Organic_powder25kg + item.formula_6_3_3
            , sum_chemical: item.formula_15_5_30 + item.formula_20_5_28
            , select: false
          };
        });
        this.data_list = data;
        let dataS = data.filter((data) => (data.partcode) == "BRD");
        this.createChart(dataS[0]);
      }
      else {
        this.data_list = [];
      }
    }).catch(err => {
      throw (err)
    });
  }

  createChart(data): void {
    const formatterWithCommas = (value: number, fd: number): string => {
      return new Intl.NumberFormat('en-US', {
        maximumFractionDigits: fd,
      }).format(value);
    };

    const label_area = ['ER', 'ERO', 'SR', 'ST', 'รวม'];
    const landValuesTarget = [data.target_er, data.target_ero, data.target_sr, data.target_st, data.sum_areas];
    const landValuesCurrent = [data.landvalue_er, data.landvalue_ero, data.landvalue_sr, data.landvalue_st, data.landvalue];
    const landValuesPrevious = [data.landvalue_erY, data.landvalue_eroY, data.landvalue_srY, data.landvalue_stY, data.landvalue_Y];
    const land_pc_Y = [data.pc_erY, data.pc_eroY, data.pc_srY, data.pc_stY, data.pc_landvalue_Y];
    //console.log('createChart:', data);

    this.chartOptions_area = {
      title: {
        text: 'พื้นที่ปลูก ' + data.supname,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['เป้าหมายพื้นที่', 'พื้นที่วัดแปลง', 'พื้นที่ปลูกเสร็จ', '%ปลูกเสร็จ'],
        top: '6%',
      },
      xAxis: {
        type: 'category',
        data: label_area,
        axisLabel: {
          interval: 'auto',
          rotate: 30
        },
      },
      yAxis: [
        {
          type: 'value',
          name: 'พื้นที่',
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
        {
          type: 'value',
          name: 'Percentage(%)',
          position: 'right',
          axisLabel: {
            formatter: '{value}%',
          },
        }
      ],
      series: [
        {
          name: 'เป้าหมายพื้นที่',
          data: landValuesTarget,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: 'พื้นที่วัดแปลง',
          data: landValuesCurrent,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: 'พื้นที่ปลูกเสร็จ',
          data: landValuesPrevious,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: '%ปลูกเสร็จ',
          data: land_pc_Y,
          type: 'line',
          yAxisIndex: 1, // ใช้แกน Y อันที่สอง
          label: {
            show: true,
            position: 'top',
            formatter: '{c} %', // แสดงตัวเลขพร้อมหน่วย %
          },
          lineStyle: {
            color: '#EE6666',
          },
          itemStyle: {
            color: '#EE6666',
          },
        },
      ],
    };

    const label_Assess = ['ER', 'ERO', 'SR', 'ST', 'รวม'];
    const AssessTarget = [data.target_er_ton, data.target_ero_ton, data.target_sr_ton, data.target_st_ton, data.sum_ton];
    const AssessPrevious = [data.Assess_erY, data.Assess_eroY, data.Assess_srY, data.Assess_stY, data.Assess_Y];
    const Assess_pc_Y = [data.pc_Assess_erY, data.pc_Assess_eroY, data.pc_Assess_srY, data.pc_Assess_stY, data.pc_Assess_Y];
    const legend_Assess = ['เป้าหมายปริมาณตัน', 'ปริมาณตัน', '%']

    this.chartOptions_Assess = {
      title: {
        text: 'ปริมาณตัน ' + data.supname,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: legend_Assess,
        top: '6%',
      },
      xAxis: {
        type: 'category',
        data: label_Assess,
        axisLabel: {
          interval: 'auto',
          rotate: 30
        },
      },
      yAxis: [
        {
          type: 'value',
          name: 'ปริมาณตัน',
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
        {
          type: 'value',
          name: 'Percentage(%)',
          position: 'right',
          axisLabel: {
            formatter: '{value}%',
          },
        }
      ],
      series: [
        {
          name: legend_Assess[0],
          data: AssessTarget,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: legend_Assess[1],
          data: AssessPrevious,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: legend_Assess[2],
          data: Assess_pc_Y,
          type: 'line',
          yAxisIndex: 1, // ใช้แกน Y อันที่สอง
          label: {
            show: true,
            position: 'top',
            formatter: '{c} %', // แสดงตัวเลขพร้อมหน่วย %
          },
          lineStyle: {
            color: '#EE6666',
          },
          itemStyle: {
            color: '#EE6666',
          },
        },
      ],
    };

    const label_crop_loss = ['ประเมิน', 'หักพันธุ์', 'หักสูญเสีย', 'คงเหลือเข้าหีบ'];
    const Assess = [data.Assess, data.crop_loss_amt_2, data.crop_loss_amt_3, data.Assess_Y];
    const legend_crop_loss = ['ปริมาณตัน']
    this.chartOptions_crop_loss = {
      title: {
        text: 'ประเมิน และ การหักสูญเสีย ' + data.supname,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: legend_crop_loss,
        top: '6%',
      },
      xAxis: {
        type: 'category',
        data: label_crop_loss,
        axisLabel: {
          interval: 'auto',
          rotate: 30
        },
      },
      yAxis: [
        {
          type: 'value',
          name: label_crop_loss[0],
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
      ],
      series: [
        {
          name: legend_crop_loss[0],
          data: Assess,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
      ],
    };

    const label_yield = ['ER', 'ERO', 'SR', 'ST', 'รวม'];
    const yield_Target = [data.target_yield_er, data.target_yield_ero, data.target_yield_sr, data.target_yield_st, data.target_yield];
    const yield_Previous = [data.yield_er, data.yield_ero, data.yield_sr, data.yield_st, data.yield_Y];
    const yield_pc_Y = [data.pc_yield_er, data.pc_yield_ero, data.pc_yield_sr, data.pc_yield_st, data.pc_yield];
    //console.log('createChart:', data);

    this.chartOptions_yield = {
      title: {
        text: 'yield ' + data.supname,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['เป้าหมาย yield', 'yield', '%'],
        top: '6%',
      },
      xAxis: {
        type: 'category',
        data: label_yield,
        axisLabel: {
          interval: 'auto',
          rotate: 30
        },
      },
      yAxis: [
        {
          type: 'value',
          name: 'yield',
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
        {
          type: 'value',
          name: 'Percentage(%)',
          position: 'right',
          axisLabel: {
            formatter: '{value}%',
          },
        }
      ],
      series: [
        {
          name: 'เป้าหมาย yield',
          data: yield_Target,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 2),
          },
        },
        {
          name: 'yield',
          data: yield_Previous,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 2),
          },
        },
        {
          name: '%',
          data: yield_pc_Y,
          type: 'line',
          yAxisIndex: 1, // ใช้แกน Y อันที่สอง
          label: {
            show: true,
            position: 'top',
            formatter: '{c} %', // แสดงตัวเลขพร้อมหน่วย %
          },
          lineStyle: {
            color: '#EE6666',
          },
          itemStyle: {
            color: '#EE6666',
          },
        },
      ],
    };

    const areaChart = [data.cnt, data.cntUpdate, data.cnt_aa, data.cnt_a1, data.cnt_a2, data.cnt_a3, data.cnt_a4, data.cnt_a5, data.cnt_a6, data.cnt_a71, data.cnt_a72]
    const pc_areaChart = [null, data.pc_cntUpdate, data.pc_aa, data.pc_a1, data.pc_a2, data.pc_a3, data.pc_a4, data.pc_a5, data.pc_a6, data.pc_a71, data.pc_a72]
    const areaChart_m = [null, null, data.cnt_aa_m, data.cnt_a1_m, data.cnt_a2_m, data.cnt_a3_m, data.cnt_a4_m, data.cnt_a5_m, data.cnt_a6_m, data.cnt_a71_m, data.cnt_a72_m]
    const pc_areaChart_m = [null, null, data.pc_aa_m, data.pc_a1_m, data.pc_a2_m, data.pc_a3_m, data.pc_a4_m, data.pc_a5_m, data.pc_a6_m, data.pc_a71_m, data.pc_a72_m]

    const label2 = ['แปลงทั้งหมด', 'อัพเดตแปลง', 'แปลงเกรดA', 'ระเบิดดินดาน', 'อินทรีย์', 'โดโลไมต์', '%การงอก', 'ไม่มีวัชพืช', 'ผลผลิต', 'ปุ๋ยเคมี1', 'ปุ๋ยเคมี2'];
    this.chartOptions_aaa = {
      title: {
        text: 'แปลงเกรดA ' + data.supname,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['จำนวนแปลง สะสม', '%เกรด A สะสม', 'จำนวนแปลง รายเดือน', '%เกรด A รายเดือน'],
        top: '6%',
      },
      xAxis: {
        type: 'category',
        data: label2,
        axisLabel: {
          interval: 'auto',
          rotate: 30
        },
      },
      yAxis: [
        {
          type: 'value',
          name: 'จำนวนแปลง',
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
        {
          type: 'value',
          name: 'Percentage(%)',
          position: 'right',
          axisLabel: {
            formatter: '{value}%',
          },
        }
      ],
      series: [
        {
          name: 'จำนวนแปลง สะสม',
          data: areaChart,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: '%เกรด A สะสม',
          data: pc_areaChart,
          type: 'line',
          yAxisIndex: 1, // ใช้แกน Y อันที่สอง
          label: {
            show: true,
            position: 'top',
            formatter: '{c} %', // แสดงตัวเลขพร้อมหน่วย %
          },
          lineStyle: {
            color: '#1841f5',
          },
          itemStyle: {
            color: '#1841f5',
          },
        },
        {
          name: 'จำนวนแปลง รายเดือน',
          data: areaChart_m,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: '%เกรด A รายเดือน',
          data: pc_areaChart_m,
          type: 'line',
          yAxisIndex: 1, // ใช้แกน Y อันที่สอง
          label: {
            show: true,
            position: 'top',
            formatter: '{c} %', // แสดงตัวเลขพร้อมหน่วย %
          },
          lineStyle: {
            color: '#02a636',
          },
          itemStyle: {
            color: '#02a636',
          },
        },
      ],
    };

    const label_m = ['แปลงทั้งหมด', 'อัพเดตแปลง', 'แปลงเกรดA', 'ระเบิดดินดาน', 'คัดพันธุ์', 'อินทรีย์', 'โดโลไมต์', 'พื้นที่ระบายน้ำ', 'ระยะร่อง', 'ปุ๋ยเคมี1', 'ปุ๋ยเคมี2', 'พูนโคน', '%การงอก'];
    this.chartOptions_aaa_m = {
      title: {
        text: 'แปลงเกรดA รายเดือน ' + data.supname,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['จำนวนแปลง', '%เกรด A'],
        top: '6%',
      },
      xAxis: {
        type: 'category',
        data: label_m,
        axisLabel: {
          interval: 'auto',
          rotate: 30
        },
      },
      yAxis: [
        {
          type: 'value',
          name: 'จำนวนแปลง',
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
        {
          type: 'value',
          name: 'Percentage(%)',
          position: 'right',
          axisLabel: {
            formatter: '{value}%',
          },
        }
      ],
      series: [
        {
          name: 'จำนวนแปลง',
          data: areaChart_m,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: '%เกรด A',
          data: pc_areaChart_m,
          type: 'line',
          yAxisIndex: 1, // ใช้แกน Y อันที่สอง
          label: {
            show: true,
            position: 'top',
            formatter: '{c} %', // แสดงตัวเลขพร้อมหน่วย %
          },
          lineStyle: {
            color: '#EE6666',
          },
          itemStyle: {
            color: '#EE6666',
          },
        },
      ],
    };
    const Plantfactors = [data.Organic_powder_bulk, data.Organic_granular, data.Organic_powder25kg, data.formula_6_3_3
      , data.sum_organic
    ]
    const pc_factors = [
      this.calPercent(data.landvalue_Y, data.Organic_powder_bulk)
      , this.calPercent(data.landvalue_Y, data.Organic_granular)
      , this.calPercent(data.landvalue_Y, data.Organic_powder25kg)
      , this.calPercent(data.landvalue_Y, data.formula_6_3_3)
      , this.calPercent(data.landvalue_Y, data.sum_organic)
    ]
    const label3 = ['อินทรีย์เทกอง', 'อินทรีย์อัดเม็ด', 'อินทรีย์ชนิดผง25kg', 'อินทรีย์เคมี 6-3-3', 'รวมอินทรีย์'];
    this.chartOptions_factors = {
      title: {
        text: 'การเบิกอินทรีย์/พื้นที่ปลูกเสร็จ ' + data.supname,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['การเบิก', '%การเบิก'],
        top: '6%',
      },
      xAxis: {
        type: 'category',
        data: label3,
        axisLabel: {
          interval: 'auto', rotate: 30
        },
      },
      yAxis: [
        {
          type: 'value',
          name: 'การเบิก',
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
        {
          type: 'value',
          name: 'Percentage(%)',
          position: 'right',
          axisLabel: {
            formatter: '{value}%',
          },
        }
      ],
      series: [
        {
          name: 'การเบิก',
          data: Plantfactors,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: '%การเบิก',
          data: pc_factors,
          type: 'line',
          yAxisIndex: 1, // ใช้แกน Y อันที่สอง
          label: {
            show: true,
            position: 'top',
            formatter: '{c} %', // แสดงตัวเลขพร้อมหน่วย %
          },
          lineStyle: {
            color: '#EE6666',
          },
          itemStyle: {
            color: '#EE6666',
          },
        },
      ],
    };

    const Plantfactors2 = [
      data.formula_15_5_30
      , data.formula_20_5_28
      , data.formula_15_5_20
      , data.formula_23_5_21
      , data.sum_chemical]
    const pc_factors2 = [
      this.calPercent(data.landvalue_Y, data.formula_15_5_30)
      , this.calPercent(data.landvalue_Y, data.formula_20_5_28)
      , this.calPercent(data.landvalue_Y, data.formula_15_5_20)
      , this.calPercent(data.landvalue_Y, data.formula_23_5_21)
      , this.calPercent(data.landvalue_Y, data.sum_chemical)
    ]
    const label32 = ['ปุ๋ยเคมี 15-5-30', 'ปุ๋ยเคมี 20-5-28', 'ปุ๋ยเคมี 15-5-20', 'ปุ๋ยเคมี 23-5-21', 'รวมปุ๋ยเคมี'];
    this.chartOptions_factors2 = {
      title: {
        text: 'การเบิกปุ๋ยเคมี จำนวนกระสอบ ' + data.supname,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['การเบิก', '%การเบิก'],
        top: '6%',
      },
      xAxis: {
        type: 'category',
        data: label32,
        axisLabel: {
          interval: 'auto', rotate: 30
        },
      },
      yAxis: [
        {
          type: 'value',
          name: 'การเบิก',
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
        {
          type: 'value',
          name: 'Percentage(%)',
          position: 'right',
          axisLabel: {
            formatter: '{value}%',
          },
        }
      ],
      series: [
        {
          name: 'การเบิก',
          data: Plantfactors2,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => formatterWithCommas(params.value, 0),
          },
        },
        {
          name: '%การเบิก',
          data: pc_factors2,
          type: 'line',
          yAxisIndex: 1, // ใช้แกน Y อันที่สอง
          label: {
            show: true,
            position: 'top',
            formatter: '{c} %', // แสดงตัวเลขพร้อมหน่วย %
          },
          lineStyle: {
            color: '#EE6666',
          },
          itemStyle: {
            color: '#EE6666',
          },
        },
      ],
    };

  }

  calPercent(total: number, part: number): number {
    if (total == 0) {
      console.error('Total value cannot be zero');
      return 0;
    }
    let num: number = parseFloat(((part / total) * 100).toFixed(2));
    return num;
  }

}
